import api from "config/axios.config";
import { IUser } from "types/user.type";

export const getUser = (uid: string): Promise<IUser> => {
  return api.get(`clients/${process.env.REACT_APP_CLIENT_ID}/users/uid/${uid}`);
};
